import { supabase } from "./supabase";

export const WARDROBE_BUCKET = "wardrobe-images";

export function isRemoteStoragePath(value: string) {
  return Boolean(value) && !value.startsWith("/") && !value.startsWith("http") && !value.startsWith("blob:") && !value.startsWith("data:");
}

function extensionForFile(file: File) {
  const fromName = file.name.split(".").pop()?.toLowerCase();
  if (fromName && /^[a-z0-9]+$/.test(fromName)) return fromName;
  if (file.type === "image/png") return "png";
  if (file.type === "image/webp") return "webp";
  if (file.type === "image/heic") return "heic";
  if (file.type === "image/heif") return "heif";
  return "jpg";
}

export async function uploadWardrobeImage(userId: string, itemId: string, file: File) {
  if (!supabase) throw new Error("Supabase is not configured.");
  if (!file.type.startsWith("image/")) throw new Error("Choose an image file.");

  const extension = extensionForFile(file);
  const path = `${userId}/${itemId}/${Date.now()}.${extension}`;
  const { error } = await supabase.storage.from(WARDROBE_BUCKET).upload(path, file, {
    cacheControl: "31536000",
    contentType: file.type || "image/jpeg",
    upsert: true,
  });

  if (error) throw error;
  return path;
}

export async function createWardrobeImageUrl(path: string) {
  if (!supabase) return null;

  const { data, error } = await supabase.storage.from(WARDROBE_BUCKET).createSignedUrl(path, 60 * 60);
  if (error) throw error;
  return data.signedUrl;
}
